export const FETCH_FORMS = 'ADMIN_FORMS/FETCH_FORMS';
export const FETCH_FORMS_SUCCESS = 'ADMIN_FORMS/FETCH_FORMS_SUCCESS';
export const FETCH_FORMS_ERROR = 'ADMIN_FORMS/FETCH_FORMS_ERROR';
export const FETCH_DEPARTMENTS = 'ADMIN_FORMS/FETCH_DEPARTMENTS';
export const FETCH_DEPARTMENTS_SUCCESS = 'ADMIN_FORMS/FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_ERROR = 'ADMIN_FORMS/FETCH_DEPARTMENTS_ERROR';
export const SAVE_FORM = 'ADMIN_FORMS/SAVE_FORM';
export const SAVE_FORM_SUCCESS = 'ADMIN_FORMS/SAVE_FORM_SUCCESS';
export const SAVE_FORM_ERROR = 'ADMIN_FORMS/SAVE_FORM_ERROR';
export const DELETE_FORM = 'ADMIN_FORMS/DELETE_FORM';
export const DELETE_FORM_SUCCESS = 'ADMIN_FORMS/DELETE_FORM_SUCCESS';
export const DELETE_FORM_ERROR = 'ADMIN_FORMS/DELETE_FORM_ERROR';
export const UPLOAD_FILE = 'ADMIN_FORMS/UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'ADMIN_FORMS/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_ERROR = 'ADMIN_FORMS/UPLOAD_FILE_ERROR';
export const SET_ID_MODAL = 'ADMIN_FORMS/SET_ID_MODAL';
export const SET_ACTIVE_PAGE = 'ADMIN_FORMS/SET_ACTIVE_PAGE';
export const RESET_STATE = 'ADMIN_FORMS/RESET_STATE';
export const SET_FORM = 'ADMIN_FORMS/SET_FORM';
export const SET_FORM_FIELD = 'ADMIN_FORMS/SET_FORM_FIELD';
export const SET_PDF_FILE = 'ADMIN_FORMS/SET_PDF_FILE';
export const SET_PREVIEW_FILE = 'ADMIN_FORMS/SET_PREVIEW_FILE';
export const RESET_FORM = 'ADMIN_FORMS/RESET_FORM';
export const SET_SORT = 'ADMIN_FORMS/SET_SORT';
export const SET_SEARCH = 'ADMIN_FORMS/SET_SEARCH';
export const SET_SEARCH_TYPE = 'ADMIN_FORMS/SET_SEARCH_TYPE';
export const SET_UPLOAD_FILE = 'ADMIN_FORMS/SET_UPLOAD_FILE';
export const ADD_DEPARTMENT = 'ADMIN_FORMS/ADD_DEPARTMENT';
export const DELETE_DEPARTMENT = 'ADMIN_FORMS/DELETE_DEPARTMENT';